"use client";

import { createContext, useContext } from "react";

import type { NotificationCardSceneContext } from "@components/Chat/JsonRenderComponents/type";

export interface JsonRenderRuntimeContextValue {
  scene:
    | "notification"
    | "chat"
    | "tracker"
    | "tracker-history"
    | "invest-nextmoves";
  notificationId?: string;
  collapsed?: boolean;
  metrics?: string;
  isRead?: boolean;
  title?: string;
  /** History sheet: signal record time for meta line (overrides spec generatedAtMs). */
  trackedAtMs?: number;
  /** Moves list footer relative time source (e.g. record created). */
  generatedAtMs?: number;
  /** Scene-specific card display overrides (e.g. invest-nextmoves tracker title). */
  sceneContext?: NotificationCardSceneContext;
  locale?: string;
  /** When true, meta is rendered in TrackerHistoryModal shell header. */
  suppressTrackerMeta?: boolean;
  chatId?: string;
  streamLoading?: boolean;
}

const JsonRenderRuntimeContext =
  createContext<JsonRenderRuntimeContextValue | null>(null);

interface JsonRenderRuntimeContextProviderProps {
  value: JsonRenderRuntimeContextValue;
  children: React.ReactNode;
}

export const JsonRenderRuntimeContextProvider: React.FC<
  JsonRenderRuntimeContextProviderProps
> = ({ value, children }) => (
  <JsonRenderRuntimeContext.Provider value={value}>
    {children}
  </JsonRenderRuntimeContext.Provider>
);

export const useJsonRenderRuntimeContext = () =>
  useContext(JsonRenderRuntimeContext);
